'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.email = undefined;
var _address = require('./address');
var _address2 = _interopRequireDefault(_address);
var _isAlphanumerical = require('../is-alphanumerical');
var _isAlphanumerical2 = _interopRequireDefault(_isAlphanumerical);
var _oneByOne = require('../one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _looksLikeEmail = require('../looks-like-email');
var _looksLikeEmail2 = _interopRequireDefault(_looksLikeEmail);
var _mxLookup = require('../mx-lookup');
var _mxLookup2 = _interopRequireDefault(_mxLookup);
var _required = require('../required');
var _required2 = _interopRequireDefault(_required);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var email = exports.email = (0, _oneByOne2.default)((0, _required2.default)(), (0, _looksLikeEmail2.default)(), (0, _mxLookup2.default)());
exports.default = function () {
  var addressId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'address';
  return Object.assign({}, (0, _address2.default)(addressId), {
    email: email,
    telephone: (0, _isAlphanumerical2.default)('Please let us know your phone number')
  });
};